import * as React from 'react';
import { isMobile } from '../../common/util';
import AssociatedWorkkardMobileCell from './associatedworkkardMobileCell';
import AssociatedWorkkardCell from "./associatedWorkkardCell";

export default class AssociatedWorkkardGroup extends React.Component {
    constructor(props) {
        super(props);
    }

    isItemInAccessibleOrg(data, item)
    {
        if(data.accessibleOrg.includes(item.orgId) || data.accessibleOrg.includes(item.assigneeOrgId))
        {
            return true;
        }
        return false;
    }


    render() {
        const { data, extraData,onItemClick,selectedId } = this.props;
        return (
            <div>
                <div className='awGroup alignStart'><span className="gray mr">Organization:</span>{data.orgGroup}</div>
                {data.data.map((item, key) => {
                    const newItem=Object.assign({},item,{isViewable: item.isWorkkardClickable})
                    return <React.Fragment key={key}>
                       {
                        isMobile() 
                        ?
                        <AssociatedWorkkardMobileCell data={newItem} extraData={extraData} onItemClick={onItemClick} selectedId={selectedId} />
                        :
                        <AssociatedWorkkardCell data={newItem} extraData={extraData} onItemClick={onItemClick} selectedId={selectedId} />
                       }
                     </React.Fragment>
                })}
            </div>
        );
    }
}